// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Config from "../../../../Config.bs.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as TabUIdMapper from "./TabUIdMapper.bs.js";
import * as TestComponent from "../../TestComponent.bs.js";
import * as CountryContext from "../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as SurgeDashboard from "../presentation/surge-dashboard/SurgeDashboard.bs.js";
import * as CrmRouteManager from "./CrmRouteManager.bs.js";
import * as TicketContainer from "../../ticket-dashboard/view/components/ticket-details/TicketContainer.bs.js";
import * as CustomerContainer from "../../customer-ecosystem/view/components/CustomerContainer.bs.js";
import * as CustomerOrderPage from "../../customer-ecosystem/view/components/CustomerOrderPage.bs.js";
import * as DateTime$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as CampaignOrdersList from "../../partner-dashboard/view/components/components/campaign-orders-list/CampaignOrdersList.bs.js";
import * as OrderLogsContainer from "../../order-dashboard/view/components/order-logs/OrderLogsContainer.bs.js";
import * as PpSubscriptionList from "../../partner-dashboard/view/components/components/premium-partner-report/PpSubscriptionList.bs.js";
import * as AdjustFareContainer from "../../adjust-fare/view/components/AdjustFareContainer.bs.js";
import * as DriverSuspensionList from "../../partner-dashboard/view/components/components/suspension-list/DriverSuspensionList.bs.js";
import * as FilterOrderComponent from "../../filter-order/view/FilterOrderComponent.bs.js";
import * as PorterStoreComponent from "../../porter-store/view/PorterStoreComponent.bs.js";
import * as DriverTerminationList from "../../partner-dashboard/view/components/components/termination-list/DriverTerminationList.bs.js";
import * as FilterTicketComponent from "../../ticket-dashboard/view/components/filter-tickets/FilterTicketComponent.bs.js";
import * as IFrameLoader$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/custom/iframe/IFrameLoader.bs.js";
import * as CreateManualPenaltyCmp from "../../partner-penalty/view/components/CreateManualPenaltyCmp.bs.js";
import * as DriverIncentiveListCmp from "../../partner-dashboard/view/components/components/incentive-list/DriverIncentiveListCmp.bs.js";
import * as DriverRecordsComponent from "../../partner-dashboard/view/components/components/driver-records/DriverRecordsComponent.bs.js";
import * as FilterPartnerComponent from "../../partner-dashboard/view/components/components/filter-partners/FilterPartnerComponent.bs.js";
import * as SendSMSSearchContainer from "../../send-sms/view/components/SendSMSSearchContainer.bs.js";
import * as CreateCustomerComponent from "../../create-customer/view/components/CreateCustomerComponent.bs.js";
import * as DriverLeadPageDashboard from "../../driver-lead-page/view/components/DriverLeadPageDashboard.bs.js";
import * as TrustAndSafetyContainer from "../../trust-and-safety/view/components/TrustAndSafetyContainer.bs.js";
import * as OrderRelatedTicketRootCmp from "../../raise-ticket/view/components/or-nor-raise-ticket/OrderRelatedTicketRootCmp.bs.js";
import * as PartnerPenaltiesContainer from "../../partner-penalty/view/components/PartnerPenaltiesContainer.bs.js";
import * as PricingDashboardContainer from "../../pricing-dashboard/view/PricingDashboardContainer.bs.js";
import * as WeeklyEarningsDetailsList from "../../partner-dashboard/view/components/components/driver-earnings-list/WeeklyEarningsDetailsList.bs.js";
import * as PartnerGoodwillDiscountCmp from "../../order-dashboard/view/components/give-goodwill-partner-bonus/PartnerGoodwillDiscountCmp.bs.js";
import * as OrderFareDashboardContainer from "../../order-dashboard/view/components/order-fare/OrderFareDashboardContainer.bs.js";
import * as RaiseTicketAgentDeskRootCmp from "../../raise-ticket/view/components/agent-desk-raise-ticket/RaiseTicketAgentDeskRootCmp.bs.js";
import * as AllocationDashboardContainer from "../../allocation-dashboard/view/components/AllocationDashboardContainer.bs.js";
import * as HelperServiceabilityListView from "../../partner-dashboard/view/components/components/serviceability-list/HelperServiceabilityListView.bs.js";
import * as NonOrderRelatedTicketRootCmp from "../../raise-ticket/view/components/or-nor-raise-ticket/NonOrderRelatedTicketRootCmp.bs.js";
import * as RentalServiceabilityListView from "../../partner-dashboard/view/components/components/serviceability-list/RentalServiceabilityListView.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as HelperLabourServiceabilityList from "../../partner-dashboard/view/components/components/serviceability-list/HelperLabourServiceabilityList.bs.js";
import * as OutboundOrderDashboardContainer from "../../order-dashboard/view/components/non-live-order-dashboard/OutboundOrderDashboardContainer.bs.js";
import * as OutStationServiceabilityListView from "../../partner-dashboard/view/components/components/serviceability-list/OutStationServiceabilityListView.bs.js";
import * as PretendAsCallerDashboardContainer from "../../pretend-as-caller/view/components/PretendAsCallerDashboardContainer.bs.js";
import * as WalletTransactionsReportComponent from "../../partner-dashboard/view/components/components/wallet-list/WalletTransactionsReportComponent.bs.js";

function checkValidUrl(iframeUrl) {
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  console.log(country);
  var regex;
  switch (country.TAG | 0) {
    case /* UAE */0 :
        regex = /^https?:\/\/([a-zA-Z0-9-]+\.)*porter\.(ae|tr|bd)(\/.*)?$/;
        break;
    case /* India */1 :
        regex = /^https?:\/\/([a-zA-Z0-9-]+\.)*porter\.in(\/.*)?$/;
        break;
    case /* BD */2 :
        regex = /^https?:\/\/([a-zA-Z0-9-]+\.)*porter\.(ae|tr|bd)(\/.*)?$/;
        break;
    case /* TR */3 :
        regex = /^https?:\/\/([a-zA-Z0-9-]+\.)*porter\.(ae|tr|bd)(\/.*)?$/;
        break;
    
  }
  var match$1 = regex.exec(iframeUrl);
  if (match$1 !== null) {
    return iframeUrl;
  } else {
    return "/";
  }
}

function getTabData(tab) {
  if (typeof tab === "number") {
    switch (tab) {
      case /* Test */0 :
          return {
                  component: React.createElement(TestComponent.make, {}),
                  label: "Test"
                };
      case /* AllocationDashboard */1 :
          return {
                  component: React.createElement(AllocationDashboardContainer.make, {}),
                  label: "Allocation Dashboard"
                };
      case /* SendSMS */2 :
          return {
                  component: React.createElement(SendSMSSearchContainer.make, {}),
                  label: "SendSms"
                };
      case /* PorterStore */3 :
          return {
                  component: React.createElement(PorterStoreComponent.make, {}),
                  label: "Porter Store"
                };
      
    }
  } else {
    switch (tab.TAG | 0) {
      case /* PretendAsCaller */0 :
          return {
                  component: React.createElement(PretendAsCallerDashboardContainer.make, {
                        phone_number: tab._0
                      }),
                  label: "Pretend As Caller"
                };
      case /* CustomerCallerInfo */1 :
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/crm/customer/profile?customer_id=" + tab._0)
                      }),
                  label: "Customer Profile"
                };
      case /* CustomerProfileNew */2 :
          return {
                  component: React.createElement(CustomerContainer.make, {
                        phone_number: tab._0,
                        customer_id: tab._1
                      }),
                  label: "Customer Profile"
                };
      case /* CustomerOrder */3 :
          return {
                  component: React.createElement(CustomerOrderPage.make, {
                        uuid: tab._0
                      }),
                  label: "Customer Order History"
                };
      case /* UnknownCaller */4 :
          return {
                  component: React.createElement(CreateCustomerComponent.make, {
                        phone_number: tab._0
                      }),
                  label: "Unknown Caller"
                };
      case /* DriverDashboardV2 */5 :
          var msisdn = tab._0;
          return {
                  component: React.createElement(DriverRecordsComponent.make, {
                        msisdn: msisdn
                      }),
                  label: "Driver-" + msisdn
                };
      case /* DriverSuspensionList */6 :
          var driverUuid = tab._0;
          return {
                  component: React.createElement(DriverSuspensionList.SuspensionLogsLoader.make, {
                        driverUuid: driverUuid
                      }),
                  label: "Suspension Data-" + driverUuid
                };
      case /* DriverTerminationList */7 :
          var msisdn$1 = tab._0;
          return {
                  component: React.createElement(DriverTerminationList.TerminationLogsLoader.make, {
                        msisdn: msisdn$1
                      }),
                  label: "Termination Info -" + msisdn$1
                };
      case /* DriverWallet */8 :
          var msisdn$2 = tab._0;
          return {
                  component: React.createElement(WalletTransactionsReportComponent.make, {
                        msisdn: msisdn$2
                      }),
                  label: "Driver Wallet - " + msisdn$2
                };
      case /* OrderDetail */9 :
          var orderId = tab._0;
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/track-order-route?order_id=" + orderId)
                      }),
                  label: "Order " + orderId
                };
      case /* OrderDetails */10 :
          var order_crn = tab._0;
          return {
                  component: React.createElement(OutboundOrderDashboardContainer.make, {
                        order_crn: order_crn,
                        is_edit_order_open: tab._1
                      }),
                  label: "Order -" + order_crn
                };
      case /* OrderFare */11 :
          var order_crn$1 = tab.order_crn;
          return {
                  component: React.createElement(OrderFareDashboardContainer.make, {
                        order_crn: order_crn$1
                      }),
                  label: "Order Fare-" + order_crn$1
                };
      case /* NewAdjustFare */12 :
          var orderId$1 = tab._0;
          return {
                  component: React.createElement(AdjustFareContainer.make, {
                        orderId: orderId$1
                      }),
                  label: "Adjust Fare-" + orderId$1
                };
      case /* OrderLogs */13 :
          var order_id = tab._0;
          return {
                  component: React.createElement(OrderLogsContainer.make, {
                        order_id: order_id
                      }),
                  label: "Order Logs -" + order_id
                };
      case /* RaiseTicket */14 :
          var crn = tab._0;
          if (crn !== undefined) {
            return {
                    component: React.createElement(OrderRelatedTicketRootCmp.make, {
                          crn: crn
                        }),
                    label: "Raise Ticket"
                  };
          } else {
            return {
                    component: React.createElement(NonOrderRelatedTicketRootCmp.make, {}),
                    label: "Raise Ticket"
                  };
          }
      case /* EditDriver */15 :
          var msisdn$3 = tab._0;
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/administrators/edit_driver?msisdn=" + msisdn$3)
                      }),
                  label: "Edit Driver-" + msisdn$3
                };
      case /* DriverTickets */16 :
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + "/administrators/ticketing/view_tickets"
                      }),
                  label: "Tickets-" + tab._0
                };
      case /* DriverIncentivesList */17 :
          var msisdn$4 = tab._0;
          return {
                  component: React.createElement(DriverIncentiveListCmp.make, {
                        msisdn: msisdn$4
                      }),
                  label: "Incentives-" + msisdn$4
                };
      case /* DriverPenalties */18 :
          var msisdn$5 = tab._0;
          var match = process.env.INFRA_STACK;
          var tmp = match === "india" ? React.createElement(IFrameLoader$Catalyst.make, {
                  url: Config.Env.getHostName(undefined) + "/driver_manual_penalty/penalty_list_driver"
                }) : React.createElement(PartnerPenaltiesContainer.make, {
                  msisdn: msisdn$5,
                  crn: tab._1
                });
          return {
                  component: tmp,
                  label: "Penalties-" + msisdn$5
                };
      case /* DriverWeeklyEarningDetails */19 :
          var date = tab._1;
          return {
                  component: React.createElement(WeeklyEarningsDetailsList.WeeklyEarningsDetailsWrapper.make, {
                        msisdn: tab._0,
                        startDate: DateTime$Catalyst.toString("YYYY-MM-DD", date)
                      }),
                  label: "Week" + (DateTime$Catalyst.toString("YYYY-MM-DD", date) + " earnings")
                };
      case /* SurgeDashboard */20 :
          return {
                  component: React.createElement(SurgeDashboard.make, {
                        geoRegionId: tab._0
                      }),
                  label: "Surge Dashboard"
                };
      case /* MbgCampaignInfo */21 :
          var msisdn$6 = tab._0;
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/crm/promotions/driver/" + (msisdn$6 + "/campaign_info?campaign_type=1"))
                      }),
                  label: "MBG Campaign Info -" + msisdn$6
                };
      case /* InternalRedirectPath */22 :
          var label = window.decodeURIComponent(Belt_Option.getWithDefault(Belt_Option.flatMap(tab.path, (function (_path) {
                          return tab.title;
                        })), "New Tab"));
          var url = tab.path;
          var component = url !== undefined ? React.createElement(IFrameLoader$Catalyst.make, {
                  url: checkValidUrl(window.decodeURIComponent(url))
                }) : React.createElement(ErrorDisplayComponent$Catalyst.make, {
                  error: /* DefaultError */{
                    _0: {
                      title: /* InternalServerError */3,
                      message: "Something went wrong"
                    }
                  }
                });
          return {
                  component: component,
                  label: label
                };
      case /* ViewTickets */23 :
          var orderId$2 = tab._0;
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/administrators/ticketing/view_tickets?crn=" + orderId$2)
                      }),
                  label: "Tickets-" + orderId$2
                };
      case /* ViewTicketDetails */24 :
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/administrators/ticketing/view_ticket_details?case_number=" + tab._0)
                      }),
                  label: "Ticket Details"
                };
      case /* EditOrder */25 :
          var orderId$3 = tab._0;
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/administrators/edit_order?order_id=" + orderId$3)
                      }),
                  label: "Edit Order-" + orderId$3
                };
      case /* CreatePenalty */26 :
          var orderId$4 = tab.orderId;
          var match$1 = process.env.INFRA_STACK;
          var tmp$1 = match$1 === "india" ? React.createElement(IFrameLoader$Catalyst.make, {
                  url: Config.Env.getHostName(undefined) + ("/driver_manual_penalty/assign_manual_penalty?order_id=" + orderId$4)
                }) : React.createElement(CreateManualPenaltyCmp.make, {
                  orderId: orderId$4,
                  msisdn: tab.msisdn
                });
          return {
                  component: tmp$1,
                  label: "Create Penalty-" + orderId$4
                };
      case /* SendInvoice */27 :
          var orderId$5 = tab._0;
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/administrators/send_invoice_request?order_id=" + orderId$5)
                      }),
                  label: "Send Invoice-" + orderId$5
                };
      case /* GetOrderFareDetails */28 :
          var orderId$6 = tab._0;
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/administrators/order_fare_details?order_id=" + orderId$6)
                      }),
                  label: "Fare Details-" + orderId$6
                };
      case /* GiveGoodwillDiscount */29 :
          var orderId$7 = tab._0;
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/customer_discounts/new?order_id=" + orderId$7)
                      }),
                  label: "Discount-" + orderId$7
                };
      case /* SMSDetails */30 :
          var orderId$8 = tab._0;
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/orders/get_sms_details?order_id=" + orderId$8)
                      }),
                  label: "SMS Details-" + orderId$8
                };
      case /* ViewCityTollRoutes */31 :
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/administrators/show_tolls?geo_region_id=" + (tab._0 + ("&vehicle_id=" + tab._1)))
                      }),
                  label: "City Toll Routes"
                };
      case /* GiveGoodwillPartnerBonus */32 :
          var crn$1 = tab.crn;
          return {
                  component: React.createElement(PartnerGoodwillDiscountCmp.make, {
                        crn: crn$1,
                        msisdn: tab.msisdn
                      }),
                  label: "Goodwill Bonus-" + crn$1
                };
      case /* RaiseTicketFromAgentDesk */33 :
          return {
                  component: React.createElement(RaiseTicketAgentDeskRootCmp.make, {
                        params_from_agent_desk: tab._0
                      }),
                  label: "Raise Ticket Agent Desk"
                };
      case /* EditTicket */34 :
          return {
                  component: React.createElement("div", undefined, "No Data Found!"),
                  label: "Error"
                };
      case /* CustomerProfile */35 :
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/administrators/customer_account_details?customer_id=" + tab._0)
                      }),
                  label: "Customer Profile"
                };
      case /* HelperServiceabilityInfoList */36 :
          var msisdn$7 = tab._0;
          return {
                  component: React.createElement(HelperServiceabilityListView.make, {
                        msisdn: msisdn$7
                      }),
                  label: "Helper Serviceability List - " + msisdn$7
                };
      case /* OutStationServiceabilityInfoList */37 :
          var msisdn$8 = tab._0;
          return {
                  component: React.createElement(OutStationServiceabilityListView.make, {
                        msisdn: msisdn$8
                      }),
                  label: "Outstation Serviceability List - " + msisdn$8
                };
      case /* RentalServiceabilityInfoList */38 :
          var msisdn$9 = tab._0;
          return {
                  component: React.createElement(RentalServiceabilityListView.make, {
                        msisdn: msisdn$9
                      }),
                  label: "Rental Serviceability List - " + msisdn$9
                };
      case /* PremiumPartnerReport */39 :
          var msisdn$10 = tab.msisdn;
          return {
                  component: React.createElement(PpSubscriptionList.make, {
                        msisdn: msisdn$10
                      }),
                  label: "Premium Membership - " + msisdn$10
                };
      case /* FilterOrders */40 :
          return {
                  component: React.createElement(FilterOrderComponent.make, {
                        params: tab._0
                      }),
                  label: "Filter Orders"
                };
      case /* FilterPartner */41 :
          return {
                  component: React.createElement(FilterPartnerComponent.make, {
                        params: tab._0
                      }),
                  label: "Filter Partners"
                };
      case /* Tickets */42 :
          return {
                  component: React.createElement(FilterTicketComponent.make, {
                        params: tab._0
                      }),
                  label: "Filter Tickets"
                };
      case /* Ticket */43 :
          var case_number = tab.case_number;
          return {
                  component: React.createElement(TicketContainer.make, {
                        case_number: case_number
                      }),
                  label: "Ticket Details - " + case_number
                };
      case /* PricingDashboard */44 :
          var geo_region_id = tab.geo_region_id;
          return {
                  component: React.createElement(PricingDashboardContainer.make, {
                        geo_region_id: geo_region_id,
                        key: String(geo_region_id)
                      }),
                  label: "Pricing Engine"
                };
      case /* HelperLabourServiceability */45 :
          var msisdn$11 = tab.msisdn;
          return {
                  component: React.createElement(HelperLabourServiceabilityList.make, {
                        msisdn: msisdn$11
                      }),
                  label: "Helper Labour Serviceability - " + msisdn$11
                };
      case /* CampaignOrders */46 :
          var campaign_id = tab._0;
          return {
                  component: React.createElement(CampaignOrdersList.CampaignOrdersListLoader.make, {
                        campaign_id: campaign_id,
                        msisdn: tab._1
                      }),
                  label: "Campaign Orders -" + campaign_id
                };
      case /* TrustAndSafety */47 :
          var match$2;
          switch (tab.feature) {
            case /* BulkSuspensions */0 :
                match$2 = [
                  "Trust & Safety - Bulk Suspensions",
                  /* BulkSuspensions */0
                ];
                break;
            case /* PartnerBlacklist */1 :
                match$2 = [
                  "Trust & Safety - Partner Blacklist/Whitelist",
                  /* PartnerBlacklist */1
                ];
                break;
            case /* WalletWithdrawalBlock */2 :
                match$2 = [
                  "Trust & Safety - Wallet Withdrawal Block",
                  /* WalletWithdrawalBlock */2
                ];
                break;
            
          }
          return {
                  component: React.createElement(TrustAndSafetyContainer.make, {
                        initialFeature: match$2[1],
                        prefill: {
                          msisdn: tab.msisdn
                        }
                      }),
                  label: match$2[0]
                };
      case /* PlaceOrder */48 :
          return {
                  component: React.createElement(IFrameLoader$Catalyst.make, {
                        url: Config.Env.getHostName(undefined) + ("/administrators/place_order?customer_id=" + tab._0)
                      }),
                  label: "Place Order"
                };
      case /* DriverLeadPage */49 :
          var driver_number = tab._0;
          return {
                  component: React.createElement(DriverLeadPageDashboard.make, {
                        driver_number: driver_number
                      }),
                  label: "Driver-" + driver_number
                };
      
    }
  }
}

function createCRMTab(old_hashOpt, tab) {
  var old_hash = old_hashOpt !== undefined ? Caml_option.valFromOption(old_hashOpt) : undefined;
  var tabWithoutUrl = getTabData(tab);
  return {
          component: tabWithoutUrl.component,
          label: tabWithoutUrl.label,
          url: CrmRouteManager.getPathNameFromTab(tab, old_hash),
          showCancelButton: true,
          uId: TabUIdMapper.getTabUId(tab)
        };
}

export {
  createCRMTab ,
  
}
/* react Not a pure module */
